class InfoLayer {
  constructor() {
    this.domElements = {};
    this.COOKIE_NAME = 'infolayer';
    if (!this.initDomElements()) {
      return false;
    }

    this.readCookieName();

    if (!this.getCookie()) {
      this.showModal();
    }

//    this.showModal();

//    this.initBlurListener();
  }

  initDomElements() {
    this.domElements.modal = $('.info-layer');
    if (this.domElements.modal.length < -1) {
      return false;
    }

    this.domElements.modalBackdrop = $('.info-layer-backdrop');
    this.domElements.modalBackground = $('.info-layer-background');
    this.domElements.modalCloseBtn = $('.info-layer__close-btn');
    this.domElements.modalContent = this.domElements.modal.find('.info-layer-content');

    return true;
  }

  showModal() {
    this.domElements.modalBackdrop.fadeIn();
    // this.domElements.modalBackdrop.fadeIn();
    this.domElements.modalCloseBtn.focus();
    this.domElements.modalCloseBtn.one('click', () => {
      this.closeModal();
    });

    this.domElements.modalBackground.one('click', () => {
      this.closeModal();
    });

    this.domElements.modalContent.on('click', 'a', () => {
      this.closeModal();
    });

    $(document).on('keyup.modal', (event) => {
      if (event.keyCode === 27) {
        this.closeModal();
      }
    });
  }

  closeModal() {
//    this.domElements.modal.hide();
    this.domElements.modalBackdrop.hide();
    $(document).unbind('keyup.modal');
    this.setCookie();
  }

  initBlurListener() {
    this.domElements.modal.on('focusout', event => {
      if (!this.domElements.modal.has(event.relatedTarget).length) {
        this.closeModal();
      }
    });
  }

  setCookie() {
    let d = new Date();
    d.setTime(d.getTime() + 60 * 1000);

    let expires = 'expires=""';
    document.cookie = this.COOKIE_NAME + '=' + this.COOKIE_NAME + ';path=/';
  }

  getCookie() {
    let name = this.COOKIE_NAME + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for (let i = 0; i < ca.length; i++) {
      let c = ca[i];
      while (c.charAt(0) == ' ') {
        c = c.substring(1);
      }
      if (c.indexOf(name) == 0) {
        return c.substring(name.length, c.length);
      }
    }
  }

  readCookieName() {
    const cookieName = this.domElements.modal.attr('id');
    if (cookieName && cookieName.length > 0) {
      this.COOKIE_NAME = cookieName;
    }
  }
}

export default InfoLayer;
